import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const SingleSelectWrapper = styled.div`
  .single-select {
    position: relative;
    width: 100%;

    &__label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding: 0 8px 0px 12px;
      border: 1px solid ${colors.grey444};
      border-radius: 8px;
      &:not(&--disabled) {
        cursor: pointer;
      }
    }

    &__dropdown {
      position: absolute;
      left: 0;
      width: 100%;
      padding: 8px;
      max-height: 222px;
      overflow-y: auto;
      background-color: ${colors.white};
      border: 1px solid ${colors.grey444};
      border-radius: 16px;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      z-index: 10;
      display: flex;
      flex-direction: column;
    }

    &__option,
    &__footer {
      display: flex;
      align-items: center;
      padding: 8px;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        background-color: ${colors.sequenceCardHover};
      }
    }

    &__footer {
      border-top: 1px solid ${colors.grey444};
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;
